import React from 'react';
import { FadeIn } from './FadeIn';
export function AboutSection() {
  return <section id="about" className="py-24 bg-rhino-charcoal relative overflow-hidden" data-id="element-11">
      <div className="container mx-auto px-6" data-id="element-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-13">
          {/* Text Content */}
          <div className="order-2 lg:order-1" data-id="element-14">
            <FadeIn data-id="element-15">
              <div className="flex items-center gap-4 mb-6" data-id="element-16">
                <div className="h-1 w-12 bg-rhino-gold" data-id="element-17"></div>
                <h2 className="text-4xl md:text-5xl font-heading font-bold text-white tracking-wide" data-id="element-18">
                  WHO IS RHINO MAN?
                </h2>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-19">
              <div className="space-y-6 text-lg text-gray-300 leading-relaxed" data-id="element-20">
                <p className="text-2xl font-medium text-white border-l-4 border-rhino-gold pl-6 py-2" data-id="element-21">
                  Bodybuilder. Author. Man of faith. Advocate of discipline and
                  perseverance.
                </p>
                <p data-id="element-22">
                  The Rhinoman isn't just a persona; it's a testament to what
                  happens when you combine unrelenting physical discipline with
                  an unshakeable spiritual foundation.
                </p>
                <div className="bg-rhino-black/60 border-l-4 border-rhino-gold p-6 rounded-r-sm" data-id="element-23">
                  <p className="text-sm uppercase tracking-widest text-rhino-gold font-heading font-bold mb-3" data-id="element-24">
                    Our Mission
                  </p>
                  <p className="text-gray-200 italic leading-relaxed" data-id="element-25">
                    "The mission of Rhino Strong is to help enable others to
                    break free from their own hindrances or chains so as to step
                    into their God given purpose — to persevere. To inspire,
                    encourage, build confidence and strength; to master positive
                    mindset change through Biblical wisdom using the rhino as a
                    metaphor, and strength training as a platform."
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>

          {/* Image Placeholder */}
          <div className="order-1 lg:order-2" data-id="element-26">
            <FadeIn direction="left" delay={0.3} data-id="element-27">
              <div className="relative aspect-[4/5] w-full max-w-md mx-auto" data-id="element-28">
                {/* Decorative background box */}
                <div className="absolute inset-0 border-2 border-rhino-gold translate-x-4 translate-y-4 rounded-sm" data-id="element-29"></div>

                {/* Main image container */}
                <div className="absolute inset-0 rounded-sm overflow-hidden" data-id="element-30">
                  <img src="https://cdn.magicpatterns.com/uploads/rro1HV35zowSdAD3Daauuj/1000175389.jpg" alt="Rhino in the wild" className="w-full h-full object-cover" data-id="element-31" />
                  <div className="absolute inset-0 bg-gradient-to-tr from-rhino-black/60 to-transparent" data-id="element-32"></div>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}